import React from "react";

import styles from "./NecessarySupport.module.scss";

const NecessarySupport = () => {
  return (
    <div className={styles.textBackgroundContainer}>
      <img
        className={styles.iconLeft}
        src="/images/landing_page_pipfarm/coin1.png"
        alt="Coin icon"
      />
      <img
        className={styles.iconRight}
        src="/images/landing_page_pipfarm/coin2.png"
        alt="Coin icon"
      />
      <p className={styles.textContent}>
        Ưu tiên của chúng tôi là cung cấp cho các nhà giao dịch sự hỗ trợ
        cần thiết để họ có thể phát huy tối đa hiệu suất.
      </p>
    </div>
  );
};

export default NecessarySupport;
